// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pin-error {
  color: #ff0000;
  margin: 10px 0;
  text-align: center;
}
.pin-error.hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/resetPin/resetPin.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;AACR","sourcesContent":[".pin-error {\n    color: #ff0000;\n    margin: 10px 0;\n    text-align: center;\n    \n    &.hidden {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
